"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGraphUUID = exports.getGraph = exports.setGraph = void 0;

var corona_1 = require("corona");

var graph_1 = require("../types/graph");

function setGraph(graph) {
  return {
    type: graph_1.SET_GRAPH,
    graph: graph
  };
}

exports.setGraph = setGraph;

function getGraph(graph, fields) {
  if (fields === void 0) {
    fields = [corona_1.Field.Location, corona_1.Field.Meter, corona_1.Field.Modem, corona_1.Field.Fields, corona_1.Field.Scheduling, corona_1.Field.SLA];
  }

  return function (dispatch, getState) {
    return graph.get(fields, getState().authentication).then(function (g) {
      dispatch(setGraph(g));
    });
  };
}

exports.getGraph = getGraph;

function getGraphUUID(uuid, fields) {
  if (fields === void 0) {
    fields = [corona_1.Field.Location, corona_1.Field.Meter, corona_1.Field.Modem, corona_1.Field.Fields, corona_1.Field.Scheduling, corona_1.Field.SLA];
  }

  var graph = corona_1.NewNode();

  if (uuid != null && uuid.length > 20) {
    graph = new corona_1.GraphNode(new corona_1.UUID(uuid));
  }

  return getGraph(graph, fields);
}

exports.getGraphUUID = getGraphUUID;
/*export function loadUnit(uuid) {
  return function (dispatch, getState) {
    let unit = new Unit(new UUID(uuid));
    unit.load();
    dispatch(setUnit(unit));
  }
}*/